<template>
  <v-dialog v-model="dialog" max-width="600px" persistent>
    <v-card>
      <v-card-title>
        <span class="text-h6">{{ taskId ? 'Modifica Task' : 'Nuovo Task' }}</span>
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pb-0">
        <v-container class="pa-0">
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="form.description"
                label="Descrizione"
                required
                outlined
                dense
                :error-messages="errors.description"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model.number="hoursInput"
                label="Ore"
                type="number"
                step="0.5"
                min="0"
                max="24"
                outlined
                dense
                :error-messages="errors.minutes"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-menu
                v-model="dateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.task_date"
                    label="Data"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    outlined
                    dense
                    v-bind="attrs"
                    v-on="on"
                    :error-messages="errors.task_date"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="form.task_date"
                  @input="dateMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="form.order_number"
                label="N. Ordine"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions class="px-6 pb-4">
        <v-spacer></v-spacer>
        <v-btn text @click="close">Annulla</v-btn>
        <v-btn
          color="primary"
          @click="save"
          :loading="saving"
          :disabled="!isValid"
        >
          Salva
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'TaskDialogMinimal',
  props: {
    value: Boolean,
    taskId: [String, Number]
  },
  data() {
    return {
      saving: false,
      dateMenu: false,
      hoursInput: '',
      form: {
        description: '',
        minutes: 0,
        task_date: new Date().toISOString().substr(0, 10),
        order_number: ''
      },
      errors: {}
    }
  },
  computed: {
    dialog: {
      get() { return this.value; },
      set(val) { this.$emit('input', val); }
    },
    isValid() {
      return this.form.description && this.hoursInput && this.form.task_date;
    }
  },
  watch: {
    hoursInput(val) {
      // Converti ore in minuti
      this.form.minutes = Math.round(parseFloat(val) * 60) || 0;
    },
    dialog(val) {
      if (val) {
        this.loadTask();
      } else {
        this.resetForm();
      }
    }
  },
  methods: {
    async loadTask() {
      if (!this.taskId) return;

      try {
        const response = await this.$taskService.get(this.taskId);
        this.form = { ...response.data };
        // Converti minuti in ore per la visualizzazione
        this.hoursInput = response.data.minutes ? (response.data.minutes / 60).toFixed(1) : '';
      } catch (error) {
        console.error('Errore caricamento task:', error);
      }
    },

    async save() {
      this.saving = true;
      this.errors = {};

      try {
        if (this.taskId) {
          console.log('🔍 TaskDialogMinimal - Saving task:', this.taskId, 'Data:', this.form);
          const response = await this.$taskService.patch(this.taskId, this.form);
          console.log('✅ TaskDialogMinimal - Task saved successfully:', response.data);
          this.$dtoast.pop({
            preset: "success",
            content: "Task modificato con successo!"
          });
        } else {
          console.log('🔍 TaskDialogMinimal - Creating new task:', this.form);
          const response = await this.$taskService.post(this.form);
          console.log('✅ TaskDialogMinimal - Task created successfully:', response.data);
          this.$dtoast.pop({
            preset: "success",
            content: "Task creato con successo!"
          });
        }

        console.log('📤 TaskDialogMinimal - Emitting saved event');
        this.$emit('saved');
        this.close();
      } catch (error) {
        console.error('❌ TaskDialogMinimal - Save error:', error);
        if (error.response?.data) {
          this.errors = error.response.data;

          // Mostra errore specifico se disponibile
          const errorMessage = error.response.data.non_field_errors
            ? error.response.data.non_field_errors[0]
            : error.response.data.detail
            ? error.response.data.detail
            : "Errore nel salvataggio del task";

          this.$dtoast.pop({
            preset: "error",
            content: errorMessage
          });
        } else {
          this.$dtoast.pop({
            preset: "error",
            content: "Errore nel salvataggio del task"
          });
        }
        console.error('Errore salvataggio:', error);
      } finally {
        this.saving = false;
      }
    },

    close() {
      this.dialog = false;
    },

    resetForm() {
      this.hoursInput = '';
      this.form = {
        description: '',
        minutes: 0,
        task_date: new Date().toISOString().substr(0, 10),
        order_number: ''
      };
      this.errors = {};
    }
  }
}
</script>